import * as tslib_1 from "tslib";
import { OrmCatalog } from "@natiwi/core/models/catalog";
import { NatModel } from "@natiwi/core/decorators/matadata.decorator";
let OrmPartnerContract = class OrmPartnerContract extends OrmCatalog {
    constructor() {
        super();
    }
};
OrmPartnerContract = tslib_1.__decorate([
    NatModel({
        plural: 'partnerContracts',
        displayName: 'Договор партнера',
        pluralDisplayName: 'Договоры партнеров'
    })
], OrmPartnerContract);
export { OrmPartnerContract };
